import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/vigorbuy-data';

export default function SafetySection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-2xl border border-background-200/60 p-8 md:p-10">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
              <i className="ri-shield-check-line text-accent-500 text-xl"></i>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              Is VigorBuy Spreadsheet Safe?
            </h2>
          </div>

          <div className="text-foreground-600 leading-relaxed space-y-4 text-sm md:text-base mb-8">
            <p>
              Safety is one of the most important parts of online product research. Before using any shopping resource, users should always verify information, avoid suspicious links, and protect personal data. Our <strong className="text-foreground-900">VigorBuy Spreadsheet</strong> safety guide explains best practices for safer browsing and smarter purchasing decisions.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8">
            {[
              'Verify website sources before purchasing',
              'Avoid unknown payment requests and offers',
              'Protect personal information at all times',
              'Review product details carefully',
              'Use secure connections when browsing',
            ].map((item, idx) => (
              <div key={idx} className="flex items-start gap-3">
                <div className="w-5 h-5 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-accent-500 text-xs"></i>
                </div>
                <span className="text-sm text-foreground-600">{item}</span>
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Visit VigorBuy Spreadsheet Safely
              <i className="ri-shield-check-line"></i>
            </a>
            <Link
              to="/vigorbuy-spreadsheet-safety"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-background-100 text-foreground-700 font-semibold text-sm border border-background-200/60 hover:border-accent-300 hover:text-accent-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Read Full Safety Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}